import { observable } from 'mobx';
import {
    IPaymentMethod,
    TPaymentMethodModelType,
    TPaymentMethod
} from '~/types/server.types';

export class PaymentMethod implements IPaymentMethod {
    _id: string;
    _type: TPaymentMethodModelType;
    account_name: string;
    account_number_last4: string;
    account_subtype: string;
    account_type: string;
    bank_name: string;
    bank_role: string;
    city: string;
    doing_business_as_name: string;
    first_name: string;
    institution_number: string;
    is_active: string;
    last4: string;
    last_name: string;
    merchant_category_code: string;
    name: string;
    payment_method_type: TPaymentMethod;
    phone_number: string;
    routing_number_last4: string;
    state: string;
    street_address: string;
    tax_id: string;
    transit_number: string;
    type: string;
    url_product_description: string;
    zip_code: string;
    @observable debit_card_payment_method_id: string;
    @observable card_role: string;

    constructor(paymentMethod: IPaymentMethod) {
        Object.assign(this, paymentMethod);
    }
}
